import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CanvaBack from './pages/CanvaBack.tsx';
import PaymentSuccess from './pages/PaymentSuccess.tsx';
import PricingViewNew from './pages/PricingViewNew.tsx';
import AuthLayout from './layouts/AuthLayout';
import CanvaRoute from './components/CanvaRoute.tsx';
import { CanvaAuthProvider } from './contexts/CanvaAuthContext2.tsx';

function App() {
	return (
	<HelmetProvider>
		<Router>
			<Routes>
				<Route element={<AuthLayout />}>
					<Route path="/canva-back" element={<CanvaBack />} />
					<Route path="/success" element={<PaymentSuccess />} />
				</Route>

				{/* CanvaRoute */}

				<Route
					path="/canva/*"
					element={
						<CanvaAuthProvider>
							<CanvaRoute>
								<Routes>
									<Route path="/pricing" element={<PricingViewNew />} />
								</Routes>
							</CanvaRoute>
						</CanvaAuthProvider>
					}
				/>
			</Routes>
		</Router>
	</HelmetProvider>
	);
}

export default App;
